import initTabelaGenerica from '../mixins/initTabelaGenerica'
import { html as htmlGrid } from 'gridjs'
import { URLS } from '../constants/urls'

const { isFundacao } = GLOBAL

let isActivateCheckboxHeader = false

export default {
	mixins: [initTabelaGenerica],

	props: {
		query: {
			type: Object,
			default: () => ({}),
			required: false,
		},
		limparCheckboxesExterno: {
			type: Number,
			default: 0,
		},
	},

	emits: ['click-checked-cliente', 'click-unchecked-cliente', 'clear-clientes'],

	data() {
		return {
			isFundacao: isFundacao(),
			tabelaAtendimento: null,
			atendimentos: [],
			controllerCheckbox: null,
			clientesSelecionadosInternos: new Set(),
		}
	},

	computed: {
		urlCompleta() {
			const anoAtual = new Date().getFullYear()

			const params = new URLSearchParams({
				ano_inicio: 2024,
				mes_inicio_ano_inicial: '01',
				tem_atendimento: 'true',
				ano_fim: anoAtual,
				mes_fim_ano_final: '12',
				mes_inicio_ano_final: '1',
				mes_fim_ano_inicial: '12',
				...this.query,
			})

			return `${URLS.atendimento_reuniao_sai}?${params.toString()}`
		},

		columns() {
			return [
				{ id: 'id_fundacao', name: 'ID', hidden: true },
				{
					id: 'checkbox',
					name: this.headerCheckboxHTML(),
					width: '1rem',
					formatter: (cell, row) => this.bodyCheckboxHTML(row),
					sort: false,
				},
				{
					id: 'nome_fundacao',
					name: 'Nome da Fundação',
					width: '300px',
					formatter: (cell, row) => this.formatarNome(cell, row),
				},
				{
					id: 'meses_sem_reuniao',
					name: 'Meses sem Atendimento',
					width: '180px',
					formatter: (cell) => this.formatarMesesSemReuniao(cell),
					sort: {
						compare: (a, b) => {
							if (a > b) {
								return 1
							} else if (a < b) {
								return -1
							} else {
								return 0
							}
						},
					},
				},
			]
		},
	},

	watch: {
		query: {
			handler() {
				this.atualizarTabela()
			},
			deep: true,
		},
		limparCheckboxesExterno() {
			this.limparCheckboxes()
		},
	},

	methods: {
		iniciarTabela() {
			const optionsPaginacao = {
				pagination: {
					enabled: true,
					limit: 30,
					summary: true,
					server: {
						url: (urlApi, page, limit) => {
							return `${urlApi}&page=${++page}&per_page=${limit}`
						},
					},
				},
				search: {
					server: {
						url: (prev, keyword) =>
							`${prev}&search=${encodeURIComponent(keyword)}`,
					},
				},
				sort: true,
			}

			this._gridThenCallback = (response) => {
				const fundacoes = response?.meses_clientes_sem_reuniao || []
				this.atendimentos = fundacoes
				return this.formatarDadosTabela(fundacoes)
			}

			this._gridTotalCallback = (response) => {
				return response?.pagination?.total_items || 0
			}

			this.tabelaAtendimento = this.iniciarTabelaGenerica(
				this.columns,
				this.urlCompleta,
				this._gridThenCallback,
				this._gridTotalCallback,
				optionsPaginacao
			)

			this.tabelaAtendimento.render(
				document.querySelector('#tabela_atendimento_simplificada')
			)

			this.tabelaAtendimento.on('ready', () => {
				this.configurarEventosCheckbox()
			})
		},

		atualizarTabela() {
			if (!this.tabelaAtendimento) return

			this.resetarController()

			this.tabelaAtendimento
				.updateConfig({
					server: {
						url: this.urlCompleta,
						then: this._gridThenCallback,
						total: this._gridTotalCallback,
					},
				})
				.forceRender()
		},

		formatarDadosTabela(fundacoes) {
			return fundacoes.map((fundacao) => {
				return [
					fundacao.id_fundacao,
					null, // checkbox
					fundacao.nome_fundacao,
					fundacao.meses_sem_reuniao,
				]
			})
		},

		headerCheckboxHTML() {
			return htmlGrid(html`
				<label data-type="header-fundacao-checkbox" class="fundacao-checkbox">
					<input type="checkbox" />
					<span class="checkmark"></span>
				</label>
			`)
		},

		bodyCheckboxHTML(row) {
			const idFundacao = row._cells[0]?.data
			const isChecked = this.clientesSelecionadosInternos.has(idFundacao)

			return htmlGrid(html`
				<label data-type="body-fundacao-checkbox" class="fundacao-checkbox">
					<input
						type="checkbox"
						value="${idFundacao}"
						${isChecked ? 'checked' : ''} />
					<span class="checkmark"></span>
				</label>
			`)
		},

		formatarNome(cell, row) {
			const idFundacao = row._cells[0]?.data
			const fundacao = this.atendimentos.find(
				(item) => item.id_fundacao === idFundacao
			)

			const politica = fundacao?.politica
			const nomeCompleto = fundacao?.nome_completo_fundacao || cell

			return htmlGrid(html`
				<div
					class="inline-flex items-center gap-8"
					data-tippy-content="${nomeCompleto}">
					<svg
						class="h-40 w-40 shrink-0"
						style="${GLOBAL.generateAvatarColor(politica)}">
						<use xlink:href="#icon_person"></use>
					</svg>
					<span class="one-line">${cell}</span>
				</div>
			`)
		},

		formatarMesesSemReuniao(meses) {
			if (!meses && meses !== 0) return '-'

			const cor =
				meses >= 10
					? '#ec3539'
					: meses >= 7
					? '#ec3539'
					: meses >= 4
					? '#ffc107'
					: '#18b25d'

			return htmlGrid(html`
				<div style="color: ${cor}; font-weight: 500;">
					${meses} ${meses === 1 ? 'mês' : 'meses'}
				</div>
			`)
		},

		configurarEventosCheckbox() {
			let tentativa = 1
			const maxTentativas = 5

			const intervalo = setInterval(() => {
				const checkboxes = document.querySelectorAll(
					'label[data-type="body-fundacao-checkbox"] span.checkmark'
				)

				if (checkboxes.length > 0) {
					this.adicionarEventosCheckbox()
					clearInterval(intervalo)
				} else if (tentativa >= maxTentativas) {
					clearInterval(intervalo)
				} else {
					tentativa++
				}
			}, 500)
		},

		adicionarEventosCheckbox() {
			// Inicializar controller se não existir
			if (!this.controllerCheckbox) {
				this.controllerCheckbox = new AbortController()
			}

			const checkboxHeader = document.querySelector(
				'label[data-type="header-fundacao-checkbox"]'
			)
			const checkboxesBody = document.querySelectorAll(
				'label[data-type="body-fundacao-checkbox"]'
			)

			checkboxesBody.forEach((labelCheckbox) => {
				labelCheckbox.addEventListener(
					'click',
					() => {
						setTimeout(() => {
							const input = labelCheckbox.querySelector(
								'input[type="checkbox"]'
							)
							const inputHeader = checkboxHeader.querySelector(
								'input[type="checkbox"]'
							)
							const todosChecked = document.querySelectorAll(
								'label[data-type="body-fundacao-checkbox"] input[type="checkbox"]:checked'
							)

							if (input.checked) {
								this.clientesSelecionadosInternos.add(input.value)
								this.$emit('click-checked-cliente', input.value)
							} else {
								this.clientesSelecionadosInternos.delete(input.value)
								this.$emit('click-unchecked-cliente', input.value)
							}

							// Atualizar estado do header
							const checkboxesBodyAll = document.querySelectorAll(
								'label[data-type="body-fundacao-checkbox"] input[type="checkbox"]'
							)

							if (!isActivateCheckboxHeader && todosChecked.length >= 1) {
								inputHeader.indeterminate = true
								inputHeader.checked = false
								isActivateCheckboxHeader = true
							} else if (
								todosChecked.length === checkboxesBodyAll.length &&
								checkboxesBodyAll.length > 0
							) {
								inputHeader.indeterminate = false
								inputHeader.checked = true
								isActivateCheckboxHeader = true
							} else if (todosChecked.length === 0) {
								inputHeader.indeterminate = false
								inputHeader.checked = false
								isActivateCheckboxHeader = false
							}
						}, 0)
					},
					{ signal: this.controllerCheckbox.signal }
				)
			})

			// Evento do header para selecionar/desmarcar todos
			checkboxHeader?.addEventListener(
				'click',
				() => {
					setTimeout(() => {
						const inputHeader = checkboxHeader.querySelector(
							'input[type="checkbox"]'
						)
						const checkboxesBodyAll = document.querySelectorAll(
							'label[data-type="body-fundacao-checkbox"] input[type="checkbox"]'
						)

						// Se estava indeterminado ou desmarcado, marcar todos
						if (inputHeader.indeterminate || !inputHeader.checked) {
							inputHeader.indeterminate = false
							inputHeader.checked = true
							isActivateCheckboxHeader = true

							checkboxesBodyAll.forEach((checkbox) => {
								if (!checkbox.checked) {
									checkbox.checked = true
									this.clientesSelecionadosInternos.add(checkbox.value)
									this.$emit('click-checked-cliente', checkbox.value)
								}
							})
						} else {
							// Se estava marcado, desmarcar todos
							this.limparCheckboxes()
							this.$emit('clear-clientes')
						}
					}, 0)
				},
				{ signal: this.controllerCheckbox.signal }
			)
		},

		limparCheckboxes() {
			const checkboxHeader = document.querySelector(
				'label[data-type="header-fundacao-checkbox"] input[type="checkbox"]'
			)
			const checkboxesChecked = document.querySelectorAll(
				'label[data-type="body-fundacao-checkbox"] input[type="checkbox"]:checked'
			)

			checkboxesChecked.forEach((checkbox) => {
				checkbox.checked = false
				this.clientesSelecionadosInternos.delete(checkbox.value)
			})

			if (checkboxHeader) {
				checkboxHeader.indeterminate = false
				checkboxHeader.checked = false
			}

			isActivateCheckboxHeader = false
		},

		resetarController() {
			if (this.controllerCheckbox) {
				this.controllerCheckbox.abort()
			}
			this.controllerCheckbox = new AbortController()
		},
	},

	mounted() {
		this.iniciarTabela()

		setTimeout(() => {
			tippy('[data-tippy-content]', {
				allowHTML: true,
				placement: 'top',
				boundary: 'HTMLElement',
			})
		}, 1000)
	},

	beforeUnmount() {
		if (this.controllerCheckbox) {
			this.controllerCheckbox.abort()
		}
	},

	template: html`
		<div
			class="w-full !max-h-[44rem] overflow-y-auto overflow-x-scroll flex-1 table-wrapper">
			<table
				id="tabela_atendimento_simplificada"
				class="!flex"
				js-table-ordenation></table>
		</div>
	`,
}
